import { Tooltip } from '@sede-enterprise/shell-ds-react-framework';
import { DynatraceTriggerAction } from 'components/DynatraceTriggerAction/dynatrace-trigger-action';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import {
  TooltipColorBar,
  TooltipContainer,
  TooltipItem,
  TooltipItemText,
} from 'components/Tooltip/MarketAreaTradeDetail.styled';
import { TooltipContent } from 'components/Tooltip/Tooltip.styled';
import { DYNATRACE_ACTIONS } from 'constants/dynatrace-actions';
import { SPACING_3 } from 'constants/theme-constants';
import { StackedBarItem } from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/RevenueBreakdownCard.styled';
import { RevenueBreakdown } from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/RevenueBreakdownCard.types';
import {
  capitalizeSpecificFirstMarketWords,
  convertTitleCase,
} from 'pages/Optimisation/components/SummaryCards/RevenueBreakdownCard/utils';
import { COLOR_MAP } from 'pages/Optimisation/constants';

export const revenueBreakdownColorMap = {
  ...COLOR_MAP.ancillary,
  ...COLOR_MAP.wholesale,
  ...COLOR_MAP.balancingMechanism,
};

type BreakdownTooltipsProps = {
  sortedMarketData: Array<RevenueBreakdown>;
  getRevenuePercentage: (market: RevenueBreakdown) => number;
  getPercentageOfGainOrLoss: (market: RevenueBreakdown) => number;
};

export const BreakdownTooltips = ({
  sortedMarketData,
  getRevenuePercentage,
  getPercentageOfGainOrLoss,
}: BreakdownTooltipsProps) => {
  return (
    <>
      {sortedMarketData.map((market) => (
        <Tooltip
          data-testid={'bar-item'}
          key={market?.market}
          placement="bottom"
          overlay={
            <TooltipContent
              style={{
                padding: `${cxTheme.spacing[SPACING_3]}`,
              }}
            >
              <TooltipContainer>
                <TooltipColorBar
                  $color={
                    revenueBreakdownColorMap[
                      market.market as keyof typeof revenueBreakdownColorMap
                    ] || 'defaultColor'
                  }
                />
                <TooltipItem>
                  <TooltipItemText>
                    {capitalizeSpecificFirstMarketWords(
                      convertTitleCase(
                        market?.market === 'longTermHedge'
                          ? 'otc'
                          : market?.market,
                      ),
                    )}
                  </TooltipItemText>
                  <TooltipItemText>{`${getPercentageOfGainOrLoss(
                    market,
                  )}%`}</TooltipItemText>
                  <TooltipItemText>
                    {market.revenue < 0 ? '- £' : '+ £'}
                    {Math.abs(market.revenue).toLocaleString('en-GB', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                    <DynatraceTriggerAction
                      action={DYNATRACE_ACTIONS.TOOLTIP_REVENUE_BREAKDOWN}
                    />
                  </TooltipItemText>
                </TooltipItem>
              </TooltipContainer>
            </TooltipContent>
          }
          trigger={
            <StackedBarItem
              data-testid={'bar-item'}
              style={{
                width: `${getRevenuePercentage(market)}%`,
                backgroundColor:
                  revenueBreakdownColorMap[
                    market.market as keyof typeof revenueBreakdownColorMap
                  ],
              }}
            />
          }
        />
      ))}
    </>
  );
};
